import React, { useEffect, useState } from "react";

const RADIUS = 28;
const SIZE = 75;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const URGENT_AT = 10;

const Timer = ({ initialTime, socket }) => {
  const [time, setTime] = useState(initialTime);

  useEffect(() => {
    setTime(initialTime);
  }, [initialTime]);

  // The server owns the clock and ticks every second; the client only draws it.
  useEffect(() => {
    if (!socket) return;

    const onTick = (value) => setTime(value);
    socket.on("setTimer", onTick);
    return () => socket.off("setTimer", onTick);
  }, [socket]);

  const remaining = Math.max(0, time);
  const fraction = initialTime > 0 ? remaining / initialTime : 0;
  const dashoffset = -(CIRCUMFERENCE - fraction * CIRCUMFERENCE);
  const isUrgent = remaining > 0 && remaining <= URGENT_AT;

  return (
    <div className={`timer${isUrgent ? " timer--urgent" : ""}`}>
      {/* viewBox lets the ring scale with the element; without it a smaller
          width just crops the circle. */}
      <svg
        viewBox={`0 0 ${SIZE} ${SIZE}`}
        width="100%"
        height="100%"
        aria-hidden="true"
        focusable="false"
      >
        <circle
          className="timer-track"
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          strokeWidth="3.75"
        />
        <circle
          className="timer-progress"
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          strokeWidth="3.75"
          strokeLinecap="round"
          style={{
            strokeDasharray: CIRCUMFERENCE,
            strokeDashoffset: dashoffset,
          }}
        />
      </svg>
      <div className="timer-value">
        {/* Announced once a turn rather than every second. */}
        <h2 aria-live="off">{remaining}</h2>
        <span className="visually-hidden" aria-live="polite">
          {isUrgent && remaining === URGENT_AT ? "Ten seconds left" : ""}
        </span>
      </div>
    </div>
  );
};

export default Timer;
